import { render, staticRenderFns } from "./layoutSite.vue?vue&type=template&id=b722477e&scoped=true"
import script from "./layoutSite.vue?vue&type=script&lang=js"
export * from "./layoutSite.vue?vue&type=script&lang=js"
import style0 from "./layoutSite.vue?vue&type=style&index=0&id=b722477e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b722477e",
  null
  
)

export default component.exports